import { Title, DesignTokens } from "melco-ui";
import { StatisticsConfig } from "../../../../hooks/reporting/statistics/useStatistics";
import { StatisticsStackedBarChart } from "./StatisticsStackedBarChart";
import { ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsStatisticListItem } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

const { colors } = DesignTokens;

const COLORS_CHART_POSITIVE = colors.feedback.success;
const COLORS_CHART_NEGATIVE = colors.feedback.error;

type RunDownTimeProps = {
  dataConfig?: StatisticsConfig;
  data?: ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsStatisticListItem;
  isLoading?: boolean;
};

export const RunDownTime: React.FC<RunDownTimeProps> = ({
  data,
  dataConfig,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Title level={5}>{t("reporting.statistics.charts.run_down_time")}</Title>
      <StatisticsStackedBarChart
        fields={["total_running_time", "total_standby_time"]}
        fieldColors={[COLORS_CHART_POSITIVE, COLORS_CHART_NEGATIVE]}
        dataConfig={{ ...dataConfig, sortBy: "total_running_time" }}
        data={data}
        isLoading={isLoading}
      />
    </>
  );
};
